// @ts-nocheck
/* eslint-disable */
import React from 'react';
import { useLocation } from 'react-router-dom';
import ViewEntity from '../../components/CRUD/ViewEntity';
import moment from 'moment';

const ViewDiscountBandAssignment = () => {
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const customBackUrl = searchParams.get('backUrl');

  return (
    <ViewEntity
      pageTitle="DiscountBandAssignmentInfo"
      fetchApiUrl={`${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/web_portal/fare_media_policy_capping/discount_band_assignment/:id`}
      fetchApiMethod="GET"
      dataPath="data.data"
      additionalApis={[
        {
          name: 'ticketsCount',
          url: (mainData) => `/api/v1/web_portal/fare_media_policy_capping/fare_media_policy_capping_statistics/discount-band-assignments/${mainData.discount_band_assignments_id}/tickets-count`,
          method: 'GET',
          dataPath: 'data.data.tickets_count'
        },
        {
          name: 'bandDetails',
          url: (mainData: any) => `/api/v1/web_portal/fare_media_policy_capping/discount_band/${mainData.discount_bands_id}`,
          method: 'GET',
          dataPath: 'data.data'
        },
        {
          name: 'bandStats',
          url: (mainData: any) => `/api/v1/web_portal/fare_media_policy_capping/fare_media_policy_capping_statistics/discount-band-group-stats?discount_bands_id=${mainData.discount_bands_id}&passengers_groups_id=${mainData.passengers_groups_id}`,
          method: 'GET',
          dataPath: 'data.data'
        }
      ]}
      fields={[
        {
          name: 'discount_band_name',
          labelKey: 'DiscountBand',
          type: 'text',
        },
        {
          name: 'band_type',
          labelKey: 'Type',
          type: 'custom',
          render: (data, additionalData) => {
            const band = additionalData.bandDetails;
            if (!band) return '-';
            return band.discount_pct !== null ? 'Percentage' : 'Fixed Amount';
          }
        },
        {
          name: 'band_value',
          labelKey: 'Value',
          type: 'custom',
          render: (data, additionalData) => {
            const band = additionalData.bandDetails;
            if (!band) return '-';
            return band.discount_pct !== null ? `${band.discount_pct}%` : `${band.discount_amount} EGP`;
          }
        },
        {
          name: 'band_time_window',
          labelKey: 'TimeWindow',
          type: 'custom',
          render: (data, additionalData) => {
            const band = additionalData.bandDetails;
            if (!band) return '-';
            if (!band.valid_time_from && !band.valid_time_to) return 'Open';
            return `${band.valid_time_from || 'Open'} - ${band.valid_time_to || 'Open'}`;
          }
        },
        {
          name: 'band_date_window',
          labelKey: 'BandDateValidity',
          type: 'custom',
          render: (data, additionalData) => {
            const band = additionalData.bandDetails;
            if (!band) return '-';
            const start = band.valid_date_from ? band.valid_date_from.split('T')[0] : 'Open';
            const end = band.valid_date_to ? band.valid_date_to.split('T')[0] : 'Open';
            return `${start} - ${end}`;
          }
        },
        {
          name: 'organisations_id',
          labelKey: 'Organisation',
          type: 'custom',
          render: (data) => (
            currentLanguageCode === 'en-us' ? data.org_en_name : data.org_ar_name
          ),
        },
        {
          name: 'passengers_group_name',
          labelKey: 'PassengersGroup',
          type: 'text',
        },
        {
          name: 'total_fare_media_in_group',
          labelKey: 'TotalFareMediaInGroup',
          type: 'custom',
          render: (data: any, additionalData: any) => {
            return additionalData.bandStats?.fare_media_count !== undefined ? additionalData.bandStats.fare_media_count : '-';
          }
        },
        {
          name: 'unique_fare_media_with_offer',
          labelKey: 'UniqueFareMediaWithOffer',
          type: 'custom',
          visibleIf: (values: any, additionalData: any) => additionalData.bandStats?.is_fare_product,
          render: (data: any, additionalData: any) => {
            if (additionalData.bandStats?.is_fare_product && additionalData.bandStats?.unique_fare_media_count !== undefined && additionalData.bandStats?.fare_media_count !== undefined) {
              const uniqueCount = additionalData.bandStats.unique_fare_media_count;
              const totalCount = additionalData.bandStats.fare_media_count;
              const percentage = totalCount > 0 ? ((uniqueCount / totalCount) * 100).toFixed(2) : 0;
              return `${uniqueCount} (${percentage}%)`;
            }
            return '-';
          }
        },
        {
          name: 'assigned_routes',
          labelKey: 'Routes',
          type: 'custom',
          render: (data) => {
            if (!data.assigned_routes || data.assigned_routes.length === 0) return '-';
            return data.assigned_routes.map((r: any) => 
              currentLanguageCode === 'en-us' ? r.en_name : r.ar_name
            ).join(', ');
          },
        },
        {
          name: 'priority',
          labelKey: 'Priority',
          type: 'text',
        },
        {
          name: 'valid_from',
          labelKey: 'ValidFrom',
          type: 'custom',
          render: (data) => data.valid_from ? moment(data.valid_from).format('DD/MM/YYYY') : '-',
        },
        {
          name: 'valid_to',
          labelKey: 'ValidTo',
          type: 'custom',
          render: (data) => data.valid_to ? moment(data.valid_to).format('DD/MM/YYYY') : '-',
        },
        {
          name: 'tickets_count',
          labelKey: 'AssociatedTickets',
          type: 'custom',
          render: (data, additionalData) => {
            return additionalData.ticketsCount !== undefined ? additionalData.ticketsCount : '-';
          }
        },
        {
          name: 'created_by_name',
          labelKey: 'CreatedBy',
          type: 'text',
        },
        {
          name: 'created_at',
          labelKey: 'CreatedAt',
          type: 'date',
        },
        {
          name: 'updated_by_name',
          labelKey: 'UpdatedBy',
          type: 'text',
        },
        {
          name: 'updated_at',
          labelKey: 'UpdatedAt',
          type: 'date',
        }
      ]}
      renderAboveData={(data, additionalData, intl) => {
        const band = additionalData.bandDetails;
        if (band && band.is_active === false) {
          return (
            <div style={{ backgroundColor: '#ffe5e5', border: '1px solid #ff4d4f', padding: '10px 15px', borderRadius: '5px', marginBottom: '20px', display: 'flex', alignItems: 'center' }}>
              <span style={{ fontSize: '20px', marginRight: '10px', color: '#ff4d4f' }}>⚠</span>
              <span style={{ color: '#cf1322', fontWeight: 500, fontSize: '15px' }}>
                {intl.formatMessage({ id: 'AssignmentLinkedToInactiveBand' })}
              </span>
            </div>
          );
        }
        return null;
      }}
      editUrl="/fare-products/discount-band-assignment/:id/edit"
      deleteApiUrl="/api/v1/web_portal/fare_media_policy_capping/discount_band_assignment/:id"
      deleteApiMethod="PATCH"
      buildDeletePayload={(data) => ({ is_active: false })}
      backUrl={customBackUrl || "/fare-products/discount-band-assignment"}
      buildTitle={(data) => `${data.discount_band_name}`}
      showEditButton={true}
      showDeleteButton={true}
      subsystemName="DiscountBandAssignment"
      permissionSystem="fares"
    />
  );
};

export default ViewDiscountBandAssignment;
